"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icons = _interopRequireDefault(require("../Common/Icons"));

var _wrapper = require("@uniqore/wrapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FlowNav = ({
  actionComponents = [],
  actionDirection = 'row',
  buttonsColor = 'primary',
  marginHorizontal,
  marginVertical,
  marginTop,
  marginBottom,
  className,
  style
}) => {
  return _react.default.createElement(_wrapper.UqBox, {
    marginVertical: marginVertical,
    marginHorizontal: marginHorizontal,
    marginTop: marginTop,
    marginBottom: marginBottom,
    style: style,
    className: className
  }, _react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: actionDirection,
      justifyContent: 'space-between'
    }
  }, actionComponents.map((button, i) => {
    if (_react.default.isValidElement(button)) return button;
    const {
      onClick,
      text,
      variant,
      color,
      size,
      disabled,
      fullWidth,
      startIcon,
      endIcon
    } = button;
    return _react.default.createElement(_wrapper.UqButton, {
      key: i,
      color: color === 'inherit' ? buttonsColor : color || buttonsColor,
      variant: variant || 'contained',
      size: size || 'large',
      disabled: disabled,
      fullWidth: fullWidth !== false,
      onClick: onClick,
      startIcon: startIcon ? _react.default.createElement(_Icons.default[startIcon]) : null,
      endIcon: endIcon ? _react.default.createElement(_Icons.default[endIcon]) : null,
      marginVertical: 4,
      marginHorizontal: 4
    }, text);
  })));
};

var _default = FlowNav;
exports.default = _default;